import styles from "./styles/collapsibleTabs.module.css";

const CollapsibleTabs = ({ tabs, setOpenTab, openTab, onClickIbanFunc }) => {
  const toggleTab = (tab) => {
    setOpenTab((prevTab) => (prevTab === tab ? null : tab));
  };

  return (
    <div className={styles.container}>
      {tabs.map(({ id, title, content }) => (
        <div key={id}>
          <div
            onClick={() => {
              toggleTab(id);

              if (id === "iban") {
                onClickIbanFunc();
              }
            }}
            className={styles.tabButton}
            style={
              openTab === id
                ? {
                    borderColor: "#0091EA",
                  }
                : {}
            }
          >
            {title}
          </div>
          <div
            className={`${styles.tabContent} ${
              openTab === id ? styles.open : styles.closed
            }`}
          >
            {content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CollapsibleTabs;
